import cn from 'classnames';

export const classes = {
  label: (extraClasses: string): string =>
    cn('odin-text-sm', 'odin-font-medium', extraClasses),
  value: (extraClasses: string): string =>
    cn('odin-ml-4', 'odin-text-sm', extraClasses),
};
